import * as angular from 'angular';

import { mapDirective } from '@/core/util'
import icone from './icone';

angular.module('app.directives', [])

.directive( 'icone', icone )


// WEBPACK FOOTER //
// ./src/directives/index.js